import Index from '@/components/index'
import NoSide from '@/components/noSide'
import ProjectList from '@/components/disposeAdmin/project/index'
import Home from '@/components/Home'
import RoleManage from '@/components/systemManage/roleManage'
import AccountManage from '@/components/systemManage/accountManage'
import VebateRatio from '@/components/disposeAdmin/vebateRatio'
import sryxConfigure from '@/components/disposeAdmin/sryxConfigure'
import mediaConfigure from '@/components/disposeAdmin/mediaConfigure'
import platformConfigure from '@/components/disposeAdmin/platformConfigure'
import accountConfigure from '@/components/disposeAdmin/accountConfigure'
import customerConfigure from '@/components/disposeAdmin/customerConfigure'
import mcnConfigure from '@/components/disposeAdmin/mcnConfigure'
import permissionBigClass from '@/components/systemManage/permission/index'
import orderMonthList from '@/components/Order/orderMonthList'
import placeFile from '@/components/file/placeFile'
import companyConfigure from '@/components/disposeAdmin/companyConfigure'
import examine from '@/components/examine/index'
import examineDetail from '@/components/examine/monthDetail'
import costInvoiceApplyList from '@/components/examine/costInvoiceApplyList'
import orderModifyRecords from '@/components/examine/orderModifyRecords'
import offlineCostInvoiceApplyList from '@/components/examine/offlineCostInvoiceApplyList'
import dataBulletin from '@/components/bulletin/dataBulletin'
import changeMonthTotal from '@/components/bulletin/changeMonthTotal'

import salerTable from '@/components/Order/saler/incomeTable'
import costRebate from '@/components/Order/medium/costRebate'
import totalTable from '@/components/Order/medium/totalTable'
import orderExtra from '@/components/Order/medium/orderExtra'
import mcnRebate from '@/components/Order/medium/mcnRebate'
import offlineList from '@/components/Order/medium/offlineList'
import negativeList from '@/components/Order/medium/negativeList'
import incompleteList from '@/components/Order/medium/incompleteList'
import taxRate from '@/components/disposeAdmin/taxRate'
import signCompanyList from '@/components/disposeAdmin/signCompanyList'
import incomeStatement from '@/components/newBilling/incomeStatement'
import mcnStatement from '@/components/newBilling/mcnStatement'
import statementDetail from '@/components/newBilling/statementTemplate/template'
import statementSealDetail from '@/components/newBilling/statementTemplate/templateSeal'
import myStatementApply from '@/components/newBilling/myStatementApply'
import myStatementSealApply from '@/components/newBilling/myStatementSealApply'
import statementExamine from '@/components/newBilling/examine/statementExamine'
import statementSealExamine from '@/components/newBilling/examine/statementSealExamine'
import examineStatement from '@/components/newBilling/examine/examineStatement'
import myInvoiceApply from '@/components/newBilling/myInvoiceApply'
import redInvoicesList from '@/components/newBilling/redInvoices/list'
import redInvoicesDetail from '@/components/newBilling/redInvoices/redInvoicesDetail'
import invoiceDetail from '@/components/newBilling/invoice/invoiceDetail'
import invoiceCashier from '@/components/newBilling/invoiceCashier'
import statementSealAction from '@/components/newBilling/statementSealAction'
import statementSealFile from '@/components/newBilling/statementSealFile'
import statementSealFileExport from '@/components/newBilling/statementSealFileExport'
import partyBAccount from '@/components/disposeAdmin/partyBAccount'

import list_examine from '@/components/BeforeApril/statements/list_examine'
import list_my from '@/components/BeforeApril/statements/list_my'
import listInvoice from '@/components/BeforeApril/invoice/listInvoice'
import oldInvoiceCashier from '@/components/BeforeApril/invoice/invoiceCashier'
import pastList from '@/components/BeforeApril/order/pastList'
import pastOrderExamine from '@/components/BeforeApril/order/orderExamine'
import backupList from '@/components/BeforeApril/order/backupList'
import invoiceModifyRecord from '@/components/newBilling/invoiceModifyRecord.vue'
import exportList from '@/components/exportList.vue'

export var allRouter = [
  {
    path: '/',
    name: 'index',
    component: Index,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: '/home',
        component: Home,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '新媒体事业部消耗表系统',
        }
      },

      {
        path: '/projectList',
        name: '/projectList',
        component: ProjectList,
        meta: {
          // keepAlive: true,
          isLogin: true,
          title: '项目配置',
        }
      },
      // {
      //   path: '/orderList/:project_id/:is_lock',
      //   name: '/projectList',
      //   component: OrderList,
      //   meta: {
      //     isLogin:true,
      //     title:'项目订单',
      //   }
      // },
      {
        path: '/roleManage',
        name: '/roleManage',
        component: RoleManage,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '角色管理',
        }
      },
      {
        path: '/accountManage',
        name: '/accountManage',
        component: AccountManage,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '账号管理',
        }
      },
      {
        path: '/permissionBigClass/:role_id',
        name: '/roleManage',
        component: permissionBigClass,
        meta: {
          isLogin: true,
          title: '权限管理',
        }
      },
      {
        path: '/vebateRatio',
        name: '/vebateRatio',
        component: VebateRatio,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '返点比例列表',
        }
      },
      {
        path: '/sryxConfigure',
        name: '/sryxConfigure',
        component: sryxConfigure,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '上饶易效比例配置',
        }
      },
      {
        path: '/mediaConfigure',
        name: '/mediaConfigure',
        component: mediaConfigure,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '媒体配置',
        }
      },
      {
        path: '/companyConfigure',
        name: '/companyConfigure',
        component: companyConfigure,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '付款公司配置',
        }
      },
      {
        path: '/platformConfigure',
        name: '/platformConfigure',
        component: platformConfigure,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '投放平台配置',
        }
      },
      {
        path: '/accountConfigure',
        name: '/accountConfigure',
        component: accountConfigure,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '账号配置',
        }
      },
      {
        path: '/customerConfigure',
        name: '/customerConfigure',
        component: customerConfigure,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: '客户全称配置',
        }
      },
      {
        path: '/mcnConfigure',
        name: '/mcnConfigure',
        component: mcnConfigure,
        meta: {
          keepAlive: true,
          isLogin: true,
          title: 'MCN机构全称配置',
        }
      },
      {
        path: '/orderMonthList',
        name: '/orderMonthList',
        component: orderMonthList,
        meta: {
          isLogin: true,
          title: '月度消耗表',
        }
      },
      {
        path: '/placeFile/:project_id',
        name: '/projectList',
        component: placeFile,
        meta: {
          isLogin: true,
          title: '文档管理',
        }
      },
      {
        path: '/examine',
        name: '/examine',
        component: examine,
        meta: {
          isLogin: true,
          title: '月度订单审核',
        }
      },
      {
        path: '/examineDetail/:month',
        name: '/examine',
        component: examineDetail,
        meta: {
          isLogin: true,
          title: '月度审核订单列表',
        }
      },
      {
        path: '/orderModifyRecords',
        name: '/orderModifyRecords',
        component: orderModifyRecords,
        meta: {
          isLogin: true,
          title: '订单修改记录'
        }
      },
      {
        path: '/costInvoiceApplyList',
        name: '/costInvoiceApplyList',
        component: costInvoiceApplyList,
        meta: {
          isLogin: true,
          title: '成本发票申请列表'
        }
      },
      {
        path: '/offlineCostInvoiceApplyList',
        name: '/offlineCostInvoiceApplyList',
        component: offlineCostInvoiceApplyList,
        meta: {
          isLogin: true,
          title: '线下成本发票审核列表'
        }
      },
      {
        path: '/myInvoiceApply',
        name: '/myInvoiceApply',
        component: myInvoiceApply,
        meta: {
          isLogin: true,
          title: '我的发票申请'
        }
      },
      {
        path: '/myStatementApply',
        name: '/myStatementApply',
        component: myStatementApply,
        meta: {
          isLogin: true,
          title: '我的结算单申请'
        }
      },
      {
        path: '/myStatementSealApply',
        name: '/myStatementSealApply',
        component: myStatementSealApply,
        meta: {
          isLogin: true,
          title: '我的结算单盖章申请'
        }
      },
      {
        path: '/statementExamine',
        name: '/statementExamine',
        component: statementExamine,
        meta: {
          isLogin: true,
          title: '结算单审核'
        }
      },
      {
        path: '/statementSealExamine',
        name: '/statementSealExamine',
        component: statementSealExamine,
        meta: {
          isLogin: true,
          title: '结算单盖章审核'
        }
      },
      {
        path: '/invoiceExamine',
        name: '/invoiceExamine',
        component: myInvoiceApply,
        meta: {
          isLogin: true,
          title: '发票审核'
        }
      },
      {
        path: '/invoiceModifyRecord',
        name: '/invoiceModifyRecord',
        component: invoiceModifyRecord,
        meta: {
          isLogin: true,
          title: '开票信息修改记录'
        }
      },
      {
        path: '/dataBulletin',
        name: '/dataBulletin',
        component: dataBulletin,
        meta: {
          isLogin: true,
          title: '营收及毛利润表'
        }
      },
      {
        path: '/changeMonthTotal',
        name: '/changeMonthTotal',
        component: changeMonthTotal,
        meta: {
          isLogin: true,
          title: '记账月营收及毛利润表'
        }
      },
      {
        path: '/invoiceCashier',
        name: '/invoiceCashier',
        component: invoiceCashier,
        meta: {
          isLogin: true,
          title: '发票'
        }
      },
      {
        path: '/statementSealAction',
        name: '/statementSealAction',
        component: statementSealAction,
        meta: {
          isLogin: true,
          title: '结算单盖章标记'
        }
      },
      {
        path: '/statementSealFile',
        name: '/statementSealFile',
        component: statementSealFile,
        meta: {
          isLogin: true,
          title: '结算单盖章归档'
        }
      },
      {
        path: '/statementSealFileExport',
        name: '/statementSealFile',
        component: statementSealFileExport,
        meta: {
          isLogin: true,
          title: '结算单盖章归档导出'
        }
      },
      {
        path: '/salerTable',
        name: '/salerTable',
        component: salerTable,
        meta: {
          isLogin: true,
          title: '收入表'
        }
      },
      {
        path: '/costRebate',
        name: '/costRebate',
        component: costRebate,
        meta: {
          isLogin: true,
          title: '成本与返点表'
        }
      },
      {
        path: '/totalTable',
        name: '/totalTable',
        component: totalTable,
        meta: {
          isLogin: true,
          title: '总消耗表'
        }
      },
      {
        path: '/orderExtra',
        name: '/orderExtra',
        component: orderExtra,
        meta: {
          isLogin: true,
          title: '二次修改成本返点'
        }
      },
      {
        path: '/mcnRebate',
        name: '/mcnRebate',
        component: mcnRebate,
        meta: {
          isLogin: true,
          title: 'MCN机构返点'
        }
      },
      {
        path: '/offlineList',
        name: '/offlineList',
        component: offlineList,
        meta: {
          isLogin: true,
          title: '线下补款表'
        }
      },
      {
        path: '/taxRate',
        name: '/taxRate',
        component: taxRate,
        meta: {
          isLogin: true,
          title: '成本税率配置'
        }
      },
      {
        path: '/partyBAccount',
        name: '/partyBAccount',
        component: partyBAccount,
        meta: {
          isLogin: true,
          title: '签约公司账户配置'
        }
      },
      {
        path: '/signCompanyList',
        name: '/signCompanyList',
        component: signCompanyList,
        meta: {
          isLogin: true,
          title: '签约公司配置'
        }
      },
      {
        path: '/negativeList',
        name: '/negativeList',
        component: negativeList,
        meta: {
          isLogin: true,
          title: '负利润表'
        }
      },
      {
        path: '/incompleteList',
        name: '/incompleteList',
        component: incompleteList,
        meta: {
          isLogin: true,
          title: '残缺订单表'
        }
      },
      {
        path: '/incomeStatement',
        name: '/incomeStatement',
        component: incomeStatement,
        meta: {
          isLogin: true,
          title: '收入表结算单申请'
        }
      },
      {
        path: '/mcnStatement',
        name: '/mcnStatement',
        component: mcnStatement,
        meta: {
          isLogin: true,
          title: 'MCN结算单申请'
        }
      },
      {
        path: '/listExamine',
        name: '/listExamine',
        component: list_examine,
        meta: {
          isLogin: true,
          title: '2021.04月之前结算单'
        }
      }, {
        path: '/listMy',
        name: '/listMy',
        component: list_my,
        meta: {
          isLogin: true,
          title: '我的2021.04月之前结算单'
        }
      },
      {
        path: '/listInvoice',
        name: '/listInvoice',
        component: listInvoice,
        meta: {
          isLogin: true,
          title: '2021.04月之前发票'
        }
      },
      {
        path: '/listInvoiceMy',
        name: '/listInvoiceMy',
        component: listInvoice,
        meta: {
          isLogin: true,
          title: '我的2021.04月之前发票'
        }
      },
      {
        path: '/oldInvoiceCashier',
        name: '/oldInvoiceCashier',
        component: oldInvoiceCashier,
        meta: {
          isLogin: true,
          title: '2021.04月之前出纳'
        }
      },
      {
        path: '/pastList',
        name: '/pastList',
        component: pastList,
        meta: {
          isLogin: true,
          title: '2021.04月之前订单'
        }
      },
      {
        path: '/pastOrderExamine',
        name: '/pastOrderExamine',
        component: pastOrderExamine,
        meta: {
          isLogin: true,
          title: '2021.04月之前订单审核'
        }
      },
      {
        path: '/backupList',
        name: '/backupList',
        component: backupList,
        meta: {
          isLogin: true,
          title: '记账备份列表'
        }
      },
      {
        path: '/exportList',
        name: '/exportList',
        component: exportList,
        meta: {
          isLogin: true,
          title: '导出列表'
        }
      },
      {
        path: '/redInvoicesList',
        name: '/redInvoicesList',
        component: redInvoicesList,
        meta: {
          isLogin: true,
          title: '红字发票开票申请'
        }
      },
      {
        path: '/redInvoicesExamine',
        name: '/redInvoicesExamine',
        component: redInvoicesList,
        meta: {
          isLogin: true,
          title: '红字发票审核'
        }
      },
    ]
  },
  {
    path: '/noSide',
    component: NoSide,
    children: [
      {
        path: '/statementDetail/:type',
        name: '/myStatementApply',
        component: statementDetail,
        meta: {
          isLogin: true,
          title: '申请结算单'
        }
      },
      {
        path: '/statementSealDetail/:type',
        name: '/myStatementSealApply',
        component: statementSealDetail,
        meta: {
          isLogin: true,
          title: '结算单盖章'
        }
      },
      {
        path: '/statementSealDetail/:type',
        name: '/statementSealExamine',
        component: statementSealDetail,
        meta: {
          isLogin: true,
          title: '结算单盖章'
        }
      },
      {
        path: '/statementSealDetail/:type',
        name: '/statementSealAction',
        component: statementSealDetail,
        meta: {
          isLogin: true,
          title: '结算单盖章'
        }
      },
      {
        path: '/statementSealDetail/:type',
        name: '/statementSealFile',
        component: statementSealDetail,
        meta: {
          isLogin: true,
          title: '结算单盖章'
        }
      },
      {
        path: '/invoiceExamineDetail/:invoice_id',
        name: '/invoiceExamine',
        component: invoiceDetail,
        meta: {
          isLogin: true,
          title: '发票审核'
        }
      },
      {
        path: '/invoiceDetail/:invoice_id',
        name: '/invoiceDetail',
        component: invoiceDetail,
        meta: {
          isLogin: true,
          title: '发票申请'
        }
      },
      {
        path: '/invoiceCashierDetail/:invoice_id',
        name: '/invoiceCashier',
        component: invoiceDetail,
        meta: {
          isLogin: true,
          title: '发票'
        }
      },
      {
        path: '/examineStatement/:type/:id',
        name: '/examineStatement',
        component: examineStatement,
        meta: {
          isLogin: true,
          title: '结算单详情'
        }
      },
      {
        path: '/redInvoicesDetail/:id',
        name: '/redInvoicesDetail',
        component: redInvoicesDetail,
        meta: {
          isLogin: true,
          title: '红字发票发票申请详情'
        }
      },
      {
        path: '/redInvoicesExamineDetail/:id',
        name: '/redInvoicesExamine',
        component: redInvoicesDetail,
        meta: {
          isLogin: true,
          title: '红字发票审核'
        }
      },
    ]
  }

]




// WEBPACK FOOTER //
// ./src/router/allRouter.js